import ROUTES from '~/shared/constants/routes.const'

// Oracle is intentionally unavailable on games, the employee tutor chat, mock tests and the subscription funnel
const isOracleAvailableOnPath = (asPath: string): boolean =>
  !asPath.match('/games/[0-9a-z]+') &&
  !asPath.match('/tutor/chat') &&
  !asPath.match('/test/') &&
  !asPath.match(ROUTES.SUBSCRIPTION_PAGE) &&
  !asPath.match(ROUTES.SUBSCRIPTION_CHECKOUT_PAYMENT)

export default isOracleAvailableOnPath
